// removed by extract-text-webpack-plugin
module.exports = {"spinner":"c-Spinner__spinner","spinner__item":"c-Spinner__spinner__item","SpinnerAnimation":"c-Spinner__SpinnerAnimation","animating":"c-Spinner__animating"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Spinner/Spinner.scss
// module id = 881
// module chunks = 0